import { Bold, Title } from '@panwds/react-ui';
import { animated, useSpring } from '@react-spring/web';
import React, { forwardRef, useRef } from 'react';
import { metricsHelper } from '../../../utils/metricsHelper.js';
import { useNavigationContextV3 } from '../NavigationContextV3/NavigationContextV3.js';
import { getSubMenuListClasses, getSubMenuNavClasses, getSubMenuTitleClasses, getSubMenuTitleWrapClasses } from './subMenuV3.logic.js';
export const SubMenuV3 = forwardRef(({ children, title, emptyState, className }, ref) => {
    const el = useRef(null);
    const { subNavCollapsed } = useNavigationContextV3();
    const normalizedId = metricsHelper(title?.toString() ?? 'sub-menu');
    const collapsedSubNav = (!React.Children.count(children) && !emptyState) || subNavCollapsed;
    const fadeProps = useSpring({
        opacity: !collapsedSubNav ? 1 : 0,
        config: { duration: 180 }
    });
    return (React.createElement("nav", { className: getSubMenuNavClasses(collapsedSubNav, className?.root), ref: el || ref, "aria-label": typeof title === 'string' ? title : '', "data-metrics": `navigation-${normalizedId}-subnav`, "data-testid": !collapsedSubNav ? `navigation-${normalizedId}-subnav` : undefined, "aria-hidden": collapsedSubNav, hidden: collapsedSubNav },
        React.createElement(animated.div, { style: fadeProps, className: getSubMenuTitleWrapClasses() },
            React.createElement(Title, { level: 3, size: "xxs", addClassName: getSubMenuTitleClasses(), truncate: true },
                React.createElement(Bold, null, title)),
            !React.Children.count(children) && emptyState ? emptyState : null,
            React.createElement("ul", { className: getSubMenuListClasses() }, children))));
});
//# sourceMappingURL=SubMenuV3.js.map